import { Component, OnInit, ViewChild, Inject, PLATFORM_ID } from '@angular/core';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { ApiService } from './../shared/api.service';
import {FormBuilder, FormGroup, Validators, FormControl, AbstractControl} from '@angular/forms';
import { TweenMax } from "gsap";
import { PagoDuplicado } from '../shared/pago-duplicado';
import { UploaderService } from "../shared/uploader.service";
import { DeleterService } from "../shared/deleter.service";
import * as basicLightbox from 'basiclightbox';
import * as $ from 'jquery';
import { RutService } from '../shared/rut.service';
import { ValidatorService } from '../shared/validator-service.service';
import { rutValidator, numClienteValidator } from '../shared/validator-service.service';
import { requiredFileType } from '../shared/requiredFileType.service';
import { GlobalConstants } from '../shared/global-constants';
import { NgxSpinnerService } from "ngx-spinner";
import { formatDate } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { Meta, MetaDefinition } from '@angular/platform-browser';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { environment } from '../../environments/environment';
import {Observable, of, timer} from 'rxjs';
import {map, switchMap} from 'rxjs/operators';
import { interval, Subscription } from 'rxjs';
import {DeviceDetectorService} from 'ngx-device-detector';
import { ModalNumeroClientesComponent } from '../modales/modal-numero-clientes/modal-numero-clientes.component';
import { MatDialog } from '@angular/material/dialog';
import { ModalPoliticaPrivacidadComponent } from '../modales/modal-politica-privacidad/modal-politica-privacidad.component';

@Component({
  selector: 'app-pago-doble',
  templateUrl: './pago-doble.component.html',
  styleUrls: ['./pago-doble.component.scss']
})
export class PagoDobleComponent implements OnInit {

  fileRutSol: File = null;
  fileRutSolReverso: File = null;
  fileCartolaVoucher: File = null;
  fileMontoCancelado: File = null;
  filePoderSimple:  File = null;
  formData: FormGroup;
  submitted = false;
  pasos: any;
  es: any;
  dateTime= new Date();
  // Respuesta formulario
  respuesta: any;
  plazo: number;
  userIp: string = '';

  public mimeTypes = ValidatorService.mimeTypes;

  public dataComuna: Array<any>;
  public dataComunaError: Array<any>;
  public dataRegion: Array<any>;
  public dataBanco: Array<any>;
  public dataTipoPago: Array<any>;
  public dataTipoCuenta: Array<any>;
  public dataMedioPago: Array<any>;

  @ViewChild('comuna') comuna;

  @ViewChild('comunaOk') comunaOk;

  infoMessage1: any;
  infoMessage2: any;
  infoMessage3: any;
  infoMessage4: any;
  infoMessage5: any;
  infoMessage6: any;

  tokenMessage1: any;
  tokenMessage2: any;
  tokenMessage3: any;
  tokenMessage4: any;
  tokenMessage5: any;
  tokenMessage6: any;

  errorInfoMessage1: any;
  errorInfoMessage2: any;
  errorInfoMessage3: any;
  errorInfoMessage4: any;
  errorInfoMessage5: any;
  errorInfoMessage6: any;

  file: File;
  fileName1: string = "";
  fileName2: string = "";
  fileName3: string = "";
  fileName4: string = "";
  fileName5: string = "";
  fileName6: string = "";
  extension1: string = "";
  extension2: string = "";
  extension3: string = "";
  extension4: string = "";
  extension5: string = "";
  extension6: string = "";
  imageUrl1: string | ArrayBuffer = "";
  imageUrl2: string | ArrayBuffer = "";
  imageUrl3: string | ArrayBuffer = "";
  imageUrl4: string | ArrayBuffer = "";
  imageUrl5: string | ArrayBuffer = "";
  imageUrl6: string | ArrayBuffer = "";

  public isBrowser = isPlatformBrowser(this.platformId);
  public isServer = isPlatformServer(this.platformId);

  subscription: Subscription;
  intentos = 0;
  public  spinnerMsg = '';

  constructor(
    private formBuilder: FormBuilder,
    private apiService: ApiService,
    private uploader: UploaderService,
    private deleter: DeleterService,
    private rutService: RutService,
    private spinner: NgxSpinnerService,
    private titleService: Title,
    private metaService: Meta,
    private recaptchaV3Service: ReCaptchaV3Service,
    @Inject(PLATFORM_ID) private platformId: any,
    private gtmService: GoogleTagManagerService,
    private deviceService: DeviceDetectorService,
    private dialog: MatDialog,

  ) {
    // PASOS DE LA VISTA
    this.pasos = [{
      "P1": {
        //*DevFun* Init
        "I": true,
        "CurrentNum": true
      },
      "P2": {
        "I": false,
        "CurrentNum": false
      },
      "P3": {
        "I": false,
        "CurrentNum": false
      }
    }]
  }

  ngAfterViewInit(){
    //@ts-ignore
    $('.videsk-top-container').css('display', 'none');
  }

  ngOnDestroy() {
    if(this.subscription)
    this.subscription.unsubscribe();
  }

  isMobile: boolean;
  ngOnInit() {

    this.isMobile = this.deviceService.isMobile();
    // CONTROLS FORMULARIO PASO 2
    this.formData = this.formBuilder.group({
      nombre: ['', [Validators.required, Validators.pattern(ValidatorService.nombre)]],
      rut: ['', [Validators.minLength(3), Validators.maxLength(12), Validators.required, rutValidator]],
      telefono: ['', [Validators.maxLength(9), Validators.pattern(ValidatorService.telefono)]],
      email: ['', [Validators.required, Validators.email, Validators.maxLength(200)]],
      nCliente: ['', [Validators.required, Validators.maxLength(9), Validators.pattern(ValidatorService.numeroCliente), numClienteValidator],[this.validarNumeroCliente.bind(this)]],
      direccion: ['', [Validators.required, Validators.pattern(ValidatorService.direccion)]],
      comuna: [{value: null, disabled: true}, [Validators.required]],
      region: [null, [Validators.required]],
      numClienteDuplicado: ['', [Validators.maxLength(9), Validators.pattern(ValidatorService.numeroCliente), numClienteValidator],[this.validarNumeroCliente2.bind(this)]],
      direccionPagoDuplicado: ['', [Validators.required, Validators.pattern(ValidatorService.direccion)]],
      comunaPagoDuplicado: [{value: null, disabled: true}, [Validators.required]],
      medioPago: ['', [Validators.required, Validators.pattern(ValidatorService.medioPago)]],
      direccionSucursal: ['', [Validators.pattern(ValidatorService.direccion)]],
      fechaPago: ['', [Validators.required]],
      MontoCancelado: ['', [Validators.required, Validators.min(1), Validators.max(999999999)]],
      selPagoDuplicado: [null, [Validators.required]],
      recaudadorExterno: [null, [Validators.required]],
      nombreBanco: [null, [Validators.required]],
      numCuenta: [null, [Validators.required]],
      tipocuenta: [null, [Validators.required]],
      fileRutSol: ['', [Validators.required, requiredFileType(ValidatorService.fileTypes)]],
      fileRutSolReverso: ['', [Validators.required, requiredFileType(ValidatorService.fileTypes)]],
      fileCartolaVoucher: ['', [Validators.required, requiredFileType(ValidatorService.fileTypes)]],
      filePoderSimple: ['', [ requiredFileType(ValidatorService.fileTypes)]],
      terminos: [false, [Validators.requiredTrue]],
      newsletters: [false],
      privacidad: [true],
      suscripcion: [{ value: false, disabled: false }]

    });

    this.titleService.setTitle('Corrección pago duplicado | Metrogas');
    this.metaService.updateTag({ name: 'description', content: 'Solicita la corrección de un pago realizado por error a otro domicilio.' })

    if (this.isBrowser) {
      if (environment.production) {
        this.gtmService.addGtmToDom();
      }
      this.gotoPaso(1, null);

      this.apiService.LeerRegion().subscribe(res => {
        if (res.respuesta === true) {
          this.dataRegion = this.generarDataSetRegion(res.data);
        }
      });

      this.apiService.LeerComuna().subscribe(res => {
        if (res.respuesta === true) {
          this.dataComunaError = this.generarDataSetComuna(res.data);
        }
      });

      this.es = {
        firstDayOfWeek: 1,
        dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
        dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
        dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
        monthNames: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
        monthNamesShort: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
        today: 'Hoy',
        clear: 'Borrar'
      }

      this.dataBanco = this.generarDataSetBanco();
      this.dataTipoPago = this.generarDataSetTipoPago();
      this.dataTipoCuenta = this.generarDataSetTipoCuenta();
      this.formData.get('medioPago').setValue(null);
      this.dataMedioPago = this.generarDataSetMedioPago();

    }

   // Buscar plazo
    const indice = this.apiService.configuracion.formularios.findIndex(s => s.nombre === 'Pago duplicado');
    this.plazo = this.apiService.configuracion.formularios[indice].plazo;
    console.log('Plazo', indice, this.apiService.configuracion.formularios[indice]);
    this.getUserIp();
  }



  fileRutSolProgress(fileInput: any) {
    this.fileRutSol = <File>fileInput.target.files[0];

    let file: File;
    file = <File>fileInput.target.files[0];
    this.errorInfoMessage1 = null;
    if (file) {
      this.spinner.show();
      let fileTypes = fileInput.target.accept;
      let fileType = file.type;
      var archivoValido = (fileTypes.split(',').find(x => x === fileType) === undefined) ? false : true;

      if (archivoValido) {
        this.fileName1 = file.name;
        this.extension1 = file.name.split('.').pop().toLowerCase();
        this.file = file;

        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = event => {
          this.imageUrl1 = reader.result;
        };

        if (this.infoMessage1 !== null && this.infoMessage1 !== "" && this.infoMessage1 !== undefined) {
          this.deleter.delete(this.infoMessage1, this.tokenMessage1).subscribe(message => {
          });
        }
        this.infoMessage1 = null;
        this.tokenMessage1 = null;

        this.recaptchaV3Service.execute('UploadFilepagoDuplicado')
          .subscribe(
            (token) => {
              this.uploader.upload(this.file, token).subscribe(message => {
                this.infoMessage1 = message.filename;
                this.tokenMessage1 = message.token;
                this.spinner.hide();
              });
            },
            (error) => {
              this.spinner.hide();
            },
          );
      }
      else {
        this.infoMessage1 = null;
        this.tokenMessage1 = null;
        this.errorInfoMessage1 = "Tipo de archivo inválido";
        this.spinner.hide();
      }
    }
  }

  fileCartolaVoucherProgress(fileInput: any) {
    this.fileCartolaVoucher = <File>fileInput.target.files[0];

    let file: File;
    file = <File>fileInput.target.files[0];
    this.errorInfoMessage2 = null;
    if (file) {
      this.spinner.show();
      let fileTypes = fileInput.target.accept;
      let fileType = file.type;
      var archivoValido = (fileTypes.split(',').find(x => x === fileType) === undefined) ? false : true;

      if (archivoValido) {
        this.fileName2 = file.name;
        this.extension2 = file.name.split('.').pop().toLowerCase();
        this.file = file;

        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = event => {
          this.imageUrl2 = reader.result;
        };

        if (this.infoMessage2 !== null && this.infoMessage2 !== "" && this.infoMessage2 !== undefined) {
          this.deleter.delete(this.infoMessage2, this.tokenMessage2).subscribe(message => {
          });
        }
        this.infoMessage2 = null;
        this.tokenMessage2 = null;

        this.recaptchaV3Service.execute('UploadFilepagoDuplicado')
          .subscribe(
            (token) => {
              this.uploader.upload(this.file, token).subscribe(message => {
                this.infoMessage2 = message.filename;
                this.tokenMessage2 = message.token;
                this.spinner.hide();
              });
            },
            (error) => {
              this.spinner.hide();
            },
          );
      }
      else {
        this.infoMessage2 = null;
        this.tokenMessage2 = null;
        this.errorInfoMessage2 = "Tipo de archivo inválido";
        this.spinner.hide();
      }
    }
  }

  fileRutSolReversoProgress(fileInput: any) {
    this.fileRutSolReverso = <File>fileInput.target.files[0];

    let file: File;
    file = <File>fileInput.target.files[0];
    this.errorInfoMessage3 = null;
    if (file) {
      this.spinner.show();
      let fileTypes = fileInput.target.accept;
      let fileType = file.type;
      var archivoValido = (fileTypes.split(',').find(x => x === fileType) === undefined) ? false : true;

      if (archivoValido) {
        this.fileName3 = file.name;
        this.extension3 = file.name.split('.').pop().toLowerCase();
        this.file = file;

        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = event => {
          this.imageUrl3 = reader.result;
        };

        if (this.infoMessage3 !== null && this.infoMessage3 !== "" && this.infoMessage3 !== undefined) {
          this.deleter.delete(this.infoMessage3, this.tokenMessage3).subscribe(message => {
          });
        }
        this.infoMessage3 = null;
        this.tokenMessage3 = null;

        this.recaptchaV3Service.execute('UploadFilepagoDuplicado')
          .subscribe(
            (token) => {
              this.uploader.upload(this.file, token).subscribe(message => {
                this.infoMessage3 = message.filename;
                this.tokenMessage3 = message.token;
                this.spinner.hide();
              });
            },
            (error) => {
              this.spinner.hide();
            },
          );
      }
      else {
        this.infoMessage3 = null;
        this.tokenMessage3 = null;
        this.errorInfoMessage3 = "Tipo de archivo inválido";
        this.spinner.hide();
      }
    }
  }

  fileMontoCanceladoProgress(fileInput: any) {
    this.fileRutSolReverso = <File>fileInput.target.files[0];

    let file: File;
    file = <File>fileInput.target.files[0];
    this.errorInfoMessage5 = null;
    if (file) {
      this.spinner.show();
      let fileTypes = fileInput.target.accept;
      let fileType = file.type;
      var archivoValido = (fileTypes.split(',').find(x => x === fileType) === undefined) ? false : true;

      if (archivoValido) {
        this.fileName5 = file.name;
        this.extension5 = file.name.split('.').pop().toLowerCase();
        this.file = file;

        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = event => {
          this.imageUrl5 = reader.result;
        };

        if (this.infoMessage5 !== null && this.infoMessage5 !== "" && this.infoMessage5 !== undefined) {
          this.deleter.delete(this.infoMessage5, this.tokenMessage5).subscribe(message => {
          });
        }
        this.infoMessage5 = null;
        this.tokenMessage5 = null;

        this.recaptchaV3Service.execute('UploadFilepagoDuplicado')
          .subscribe(
            (token) => {
              this.uploader.upload(this.file, token).subscribe(message => {
                this.infoMessage5 = message.filename;
                this.tokenMessage5 = message.token;
                this.spinner.hide();
              });
            },
            (error) => {
              this.spinner.hide();
            },
          );
      }
      else {
        this.infoMessage5 = null;
        this.tokenMessage5 = null;
        this.errorInfoMessage5 = "Tipo de archivo inválido";
        this.spinner.hide();
      }
    }
  }

  filePoderSimpleProgress(fileInput: any) {
    this.fileRutSolReverso = <File>fileInput.target.files[0];

    let file: File;
    file = <File>fileInput.target.files[0];
    this.errorInfoMessage6 = null;
    if (file) {
      this.spinner.show();
      let fileTypes = fileInput.target.accept;
      let fileType = file.type;
      var archivoValido = (fileTypes.split(',').find(x => x === fileType) === undefined) ? false : true;

      if (archivoValido) {
        this.fileName6 = file.name;
        this.extension6 = file.name.split('.').pop().toLowerCase();
        this.file = file;

        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = event => {
          this.imageUrl6 = reader.result;
        };

        if (this.infoMessage6 !== null && this.infoMessage6 !== "" && this.infoMessage6 !== undefined) {
          this.deleter.delete(this.infoMessage6, this.tokenMessage6).subscribe(message => {
          });
        }
        this.infoMessage6 = null;
        this.tokenMessage6 = null;

        this.recaptchaV3Service.execute('UploadFilepagoDuplicado')
          .subscribe(
            (token) => {
              this.uploader.upload(this.file, token).subscribe(message => {
                this.infoMessage6 = message.filename;
                this.tokenMessage6 = message.token;
                this.spinner.hide();
              });
            },
            (error) => {
              this.spinner.hide();
            },
          );
      }
      else {
        this.infoMessage6 = null;
        this.tokenMessage6 = null;
        this.errorInfoMessage6 = "Tipo de archivo inválido";
        this.spinner.hide();
      }
    }
  }

  eliminarArchivo(numero: number, fileUpload: string) {
    this.spinner.show();
    this.formData.controls[fileUpload].reset();
    if (numero === 1 && this.infoMessage1 !== null && this.infoMessage1 !== "" && this.infoMessage1 !== undefined) {
      this.deleter.delete(this.infoMessage1, this.tokenMessage1).subscribe(message => {
      });
      this.infoMessage1 = null;
      this.tokenMessage1 = null;
    }
    else if (numero === 2 && this.infoMessage2 !== null && this.infoMessage2 !== "" && this.infoMessage2 !== undefined) {
      this.deleter.delete(this.infoMessage2, this.tokenMessage2).subscribe(message => {
      });
      this.infoMessage2 = null;
      this.tokenMessage2 = null;
    }
    else if (numero === 3 && this.infoMessage3 !== null && this.infoMessage3 !== "" && this.infoMessage3 !== undefined) {
      this.deleter.delete(this.infoMessage3, this.tokenMessage3).subscribe(message => {
      });
      this.infoMessage3 = null;
      this.tokenMessage3 = null;
    }
    else if (numero === 4 && this.infoMessage4 !== null && this.infoMessage4 !== "" && this.infoMessage4 !== undefined) {
      this.deleter.delete(this.infoMessage4, this.tokenMessage4).subscribe(message => {
      });
      this.infoMessage4 = null;
      this.tokenMessage4 = null;
    }
    else if (numero === 5 && this.infoMessage5 !== null && this.infoMessage5 !== "" && this.infoMessage5 !== undefined) {
      this.deleter.delete(this.infoMessage5, this.tokenMessage5).subscribe(message => {
      });
      this.infoMessage5 = null;
      this.tokenMessage5 = null;
    }
    else if (numero === 6 && this.infoMessage6 !== null && this.infoMessage6 !== "" && this.infoMessage6 !== undefined) {
      this.deleter.delete(this.infoMessage6, this.tokenMessage6).subscribe(message => {
      });
      this.infoMessage6 = null;
      this.tokenMessage6 = null;
    }
    this.spinner.hide();
  }

  lightboxFile(numero: number) {
    let archivo;
    let extension;

    if (numero === 1) {
      archivo = this.imageUrl1;
      extension = this.extension1.toLowerCase();
    }
    else if (numero === 2) {
      archivo = this.imageUrl2;
      extension = this.extension2.toLowerCase();
    }
    else if (numero === 3) {
      archivo = this.imageUrl3;
      extension = this.extension3.toLowerCase();
    }
    else if (numero === 4) {
      archivo = this.imageUrl4;
      extension = this.extension4.toLowerCase();
    }
    else if (numero === 5) {
      archivo = this.imageUrl5;
      extension = this.extension5.toLowerCase();
    }
    else if (numero === 6) {
      archivo = this.imageUrl6;
      extension = this.extension6.toLowerCase();
    }

    const instance = basicLightbox.create(
      extension === "png" || extension === "pjp" || extension === "jpg" || extension === "pjpeg" || extension === "jpeg" || extension === "jfif" ?
        "<img class='zoom-ligthbox' src='" + archivo + "'>" :
        extension === "pdf" ?
          "<embed class='zoom-pdf' src='" + archivo + "' type='application/pdf' />" :
          extension === "doc" || extension === "docx" ?
            `"<iframe class='zoom-word' src='https://docs.google.com/gview?url=${GlobalConstants.apiResponseFile}&embedded=true'></iframe>"` :
            "<img class='zoom-ligthbox' src='" + archivo + "'>"
      , {
        closable: true
      });
    instance.show();
  }

  mostrarTerminos(objeto) {
    this.dialog.open(ModalPoliticaPrivacidadComponent);
  }

  mostrarPrivacidad(objeto) {
    this.lightboxDiv('.modal-privacidad');
  }

  mostrarSuscripcion(objeto) {
    //this.lightboxDiv('.modal-suscripcion');
  }

  mostrarNumeroCliente() {
    const dialogRef = this.dialog.open(ModalNumeroClientesComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result && result !== 'childClosed') {

        this.formData.patchValue({ nCliente: result });
      }
    });
  }

  mostrarnumClienteDuplicado() {
    const dialogRef = this.dialog.open(ModalNumeroClientesComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result && result !== 'childClosed') {

        this.formData.patchValue({ numClienteDuplicado: result });
      }
    });
  }

  lightboxDiv(claseCss) {
    const instance = basicLightbox.create(
      $(claseCss).get()[0].innerHTML, {
      closable: true
    });

    instance.show();
  }

  get f() { return this.formData.controls; }
  onSubmit() {
    console.log(this.formData);
    console.log(this.formData.controls.comunaPagoDoble);
    this.spinner.show();
    this.submitted = true;
    if (this.formData.invalid) {
      this.lightboxDiv('.modal-requerido');
      this.spinner.hide();
      return;
    }
    else {
      this.recaptchaV3Service.execute('SubmitpagoDuplicado')
        .subscribe(
          (token) => {
            let pagoDuplicado = new PagoDuplicado();
            pagoDuplicado.rut = this.formatearTextoRut(this.formData.value.rut);
            pagoDuplicado.nombre = this.formData.value.nombre;
            pagoDuplicado.telefono = this.formData.value.telefono;
            pagoDuplicado.email = this.formData.value.email;
            pagoDuplicado.numero_cliente = this.formData.value.nCliente;
            pagoDuplicado.direccion = this.formData.getRawValue().direccion;
            pagoDuplicado.id_comuna = this.formData.getRawValue().comuna;
            pagoDuplicado.id_region = this.formData.getRawValue().region;
            pagoDuplicado.seleccion_pago_duplicado = this.formData.value.selPagoDuplicado;
            pagoDuplicado.numero_cliente_duplicado = this.formData.value.numClienteDuplicado;
            pagoDuplicado.direccion_duplicado = this.formData.value.direccionPagoDuplicado;
            pagoDuplicado.id_comuna_duplicado = this.formData.value.comunaPagoDuplicado;
            pagoDuplicado.medio_pago_duplicado = this.formData.value.medioPago;
            pagoDuplicado.direccion_sucursal_duplicado = this.formData.value.direccionSucursal;
            pagoDuplicado.fecha_pago = this.formData.value.fechaPago;//this.formData.value.fechaPago.toLocaleDateString('en')//this.formData.value.fechaPago;
            pagoDuplicado.recaudador_externo = this.formData.value.recaudadorExterno;
            pagoDuplicado.nombre_banco = this.formData.value.nombreBanco;
            pagoDuplicado.numero_cuenta = this.formData.value.numCuenta;
            pagoDuplicado.tipo_cuenta = this.formData.value.tipocuenta;
            pagoDuplicado.monto_cancelado = this.formData.value.MontoCancelado;
            pagoDuplicado.archivo_rut_solicitante = this.infoMessage1;
            pagoDuplicado.archivo_rut_solicitante_reverso = this.infoMessage3;
            pagoDuplicado.archivo_cartola_voucher = this.infoMessage2;
            pagoDuplicado.archivo_poder_simple = this.infoMessage6;
            //pagoDuplicado.acepto_condiciones = this.formData.value.terminos === null ? false : this.formData.value.terminos;
            pagoDuplicado.acepto_newsletters = this.formData.value.newsletters === null ? false : this.formData.value.newsletters;
            pagoDuplicado.acepto_privacidad = this.formData.value.terminos === null ? false : this.formData.value.terminos;
            pagoDuplicado.acepto_suscripcion = this.formData.value.suscripcion === null ? false : this.formData.value.suscripcion;
            pagoDuplicado.token = token;
            pagoDuplicado.ip = this.userIp;

            const formulario = new FormData();
            formulario.append("data", JSON.stringify(pagoDuplicado));


            console.log(formulario);
            console.log(pagoDuplicado);


            this.apiService.AgregarPagoDuplicado(formulario, pagoDuplicado).subscribe(res => {
              if (res.respuesta === true) {
                // Acá se muestra la respuesta de la solicitud y se debe procesar
                this.spinnerMsg = GlobalConstants.mjeEspera;
                this.gotoPaso(3, res);
              }
              else {
                this.lightboxDiv('.modal-error');
                this.spinner.hide();
              }
            });
          },
          (error) => {
            this.lightboxDiv('.modal-error');
            this.spinner.hide();
          },
        );
    }
  }

  onReset() {
    this.submitted = false;
    this.formData.reset();
  }

  formatearRut(objeto) {
    objeto.target.value = this.rutService.transform(objeto.target.value);
  }

  formatearTextoRut(texto) {
    return (texto === null || texto === undefined) ? "" : this.rutService.transform(texto);
  }

  gotoPaso(index, respuesta) {
    switch (index) {
      case 1:
        this.pasos[0]['P1'].I = true;
        this.pasos[0]['P2'].I = false;
        this.pasos[0]['P3'].I = false;
        TweenMax.to('.linea-current', 0.5, {
          width: '50%', onComplete: () => {
            this.pasos[0]['P1'].CurrentNum = true;
            this.pasos[0]['P2'].CurrentNum = false;
            this.pasos[0]['P3'].CurrentNum = false;
            $(".paso-1")[0].scrollIntoView();
          }
        });
        break;
      case 2:
        this.pasos[0]['P1'].I = false;
        this.pasos[0]['P2'].I = true;
        this.pasos[0]['P3'].I = false;
        TweenMax.to('.linea-current', 0.5, {
          width: '50%', onComplete: () => {
            this.pasos[0]['P1'].CurrentNum = true;
            this.pasos[0]['P2'].CurrentNum = true;
            this.pasos[0]['P3'].CurrentNum = false;
            $(".paso-2")[0].scrollIntoView();
          }
        });
        break;
        case 3:
          this.spinner.show();
          const source = interval(2000);
          this.subscription = source.subscribe(val => {
            this.apiService.LeerAviso(respuesta.idTransaccion).subscribe( aviso => {
              let CodigoAprovacion = aviso.Mensajes.item[0].CodMensaje;
              let nombre = this.formData.value.nombre;
              let mail = this.formData.value.email;
              let codigo = aviso.NumAviso
              if (CodigoAprovacion === "000" || CodigoAprovacion === "002") {
                this.sendEmail(nombre ,mail, codigo );
              }
              if( aviso != null && aviso !== 'null'){
                this.subscription.unsubscribe();
                this.gotoPaso(4, aviso);
                this.spinner.hide();
                this.intentos = 0;
              }
              else if ( this.intentos >= GlobalConstants.reintentosSolicitud){
                this.lightboxDiv('.modal-error');
                this.subscription.unsubscribe();
                this.spinner.hide();
                this.intentos = 0;
              }else{
                this.intentos++;
              }
            },
            err => {
              console.log('ERROR: ' + err);
            }
            );

          });
          break;
        case 4:
          // Acá se debe procesar la respuesta y mandarla al componente <app-suscripcion-boleta-satisfactoria>
          this.pasos[0]['P1'].I = false;
          this.pasos[0]['P2'].I = false;
          this.pasos[0]['P3'].I = true;
          // Acá se muestra el componente de respuesta
          this.respuesta = respuesta;
          $("app-boleta").show();
          TweenMax.to('.linea-current', 1, {
            width: '100%', onComplete: () => {
              this.pasos[0]['P2'].CurrentNum = true;
              this.pasos[0]['P3'].CurrentNum = true;
              $(".paso-3")[0].scrollIntoView();
            }
          });
          break;
    }
  }

  sendEmail(nombre: string, mail: string, requestId: string) {
    this.apiService.sendEmail(nombre, mail, requestId).subscribe(
        response => {
        //console.log('Email Enviado', response);
      },
      error => {
        console.error('Error enviando email', error);
      }
    );
  }

  onChangeRegion(obj) {
    this.spinner.show();
    if (obj) {
      this.apiService.LeerComunaRegion(obj.id_region).subscribe(res => {
        if (res.respuesta === true) {
          this.dataComuna = this.generarDataSetComuna(res.data);
          this.comunaOk.handleClearClick();
        }
        this.spinner.hide();
      });
    }
    else {
      this.comunaOk.handleClearClick();
      this.spinner.hide();
    }
  }

  generarDataSetComuna(data: any) {
    data.forEach(element => {
      element.id = element.id_comuna;
    });
    return data;
  }

  generarDataSetRegion(data: any) {
    data.forEach(element => {
      element.id = element.id_region;
    });
    return data;
  }

  generarDataSetBanco() {
    let data = [];
    data.push({ id: 'bancochile', valor: 'BANCO DE CHILE / EDWARS' });
    data.push({ id: 'bancoestado', valor: 'BANCO ESTADO' });
    data.push({ id: 'bancoscotia', valor: 'SCOTIABANK CHILE' });
    data.push({ id: 'bancocredito', valor: 'BANCO DE CREDITO E INVERSIONES' });
    data.push({ id: 'bancobice', valor: 'BANCO BICE' });
    data.push({ id: 'bancosantander', valor: 'BANCO SANTANDER-CHILE' });
    data.push({ id: 'bancoitau', valor: 'BANCO ITAÚ CHILE' });
    data.push({ id: 'bancosecurity', valor: 'BANCO SECURITY' });
    data.push({ id: 'bancofalabella', valor: 'BANCO FALABELLA' });
    data.push({ id: 'bancoripley', valor: 'BANCO RIPLEY' });
    data.push({ id: 'bancoconsorcio', valor: 'BANCO CONSORCIO' });
    data.push({ id: 'bancointernacional', valor: 'BANCO INTERNACIONAL' });
    data.push({ id: 'bancohsbc', valor: 'HSBC BANK (CHILE)' });

    return data;
  }

  generarDataSetTipoPago() {
    let data = [];
    data.push({ id: 'pago_doble', valor: 'Pago doble' });
    data.push({ id: 'saldo_a_favor', valor: 'Saldo a favor' });
    return data;
  }

  generarDataSetTipoCuenta() {
    let data = [];
    data.push({ id: 'corriente', valor: 'Cuenta Corriente' });
    data.push({ id: 'vista', valor: 'Cuenta Vista' });
    return data;
  }

  generarDataSetMedioPago() {
    let data = [];
    data.push({ id: 'efectivo', valor: 'Efectivo' });
    data.push({ id: 'cheque', valor: 'Cheque' });
    data.push({ id: 'tarjeta_credito', valor: 'Tarjeta de crédito' });
    data.push({ id: 'tarjeta_debito', valor: 'Tarjeta de débito' });
    return data;
  }

  validarNumeroCliente(
    control: AbstractControl
  ): Observable<{ [key: string]: any } | null> {
    if (control.value === null || control.value.length === 0) {
      return of(null);
    } else {
      this.spinner.show();
      return timer(0).pipe(
        switchMap(() => {
          return this.apiService.checkCliente(control.value).pipe(
            map(res => {
              if (res.respuesta) {

                this.formData.patchValue({
                  direccion: res.ConsultarDireccionClientePorCtaCtoResponse.Direccion,
                  region: parseInt( res.ConsultarDireccionClientePorCtaCtoResponse.Region, 10),
                  comuna: res.ConsultarDireccionClientePorCtaCtoResponse.Comuna

                });
                this.formData.controls.direccion.disable();
                this.formData.controls.region.disable();
                this.formData.controls.comuna.disable();
                this.spinner.hide();
                return null;
              }else{
                this.lightboxDiv('.modal-error-cliente');
              }
              // SI ES INCORRECTO LIMPIAR
              this.formData.patchValue({
                direccion: null,
                region: null,
                comuna: null

              });

              this.formData.controls.direccion.enable();
              this.formData.controls.region.enable();
              this.formData.controls.comuna.enable();
              this.spinner.hide();
              return { numClienteExist: true };
            })
          );
        })
      );
    }
  }


  validarNumeroCliente2(
    control: AbstractControl
  ): Observable<{ [key: string]: any } | null> {
    if (control.value === null || control.value.length === 0) {
      return of(null);
    } else {
      this.spinner.show();
      return timer(0).pipe(
        switchMap(() => {
          return this.apiService.checkCliente(control.value).pipe(
            map(res => {
              if (res.respuesta) {

                this.formData.patchValue({
                  direccionPagoDuplicado: res.ConsultarDireccionClientePorCtaCtoResponse.Direccion,
                  comunaPagoDuplicado: res.ConsultarDireccionClientePorCtaCtoResponse.Comuna

                });
                // this.formData.controls.direccionPagoDuplicado.disable();
                // this.formData.controls.comunaPagoDuplicado.disable();
                this.spinner.hide();
                return null;
              }else{
                this.lightboxDiv('.modal-error-cliente');
                // SI ES INCORRECTO LIMPIAR
                this.formData.patchValue({
                  direccionPagoDuplicado: null,
                  comunaPagoDuplicado: null

                });
              }

              // this.formData.controls.direccionPagoDuplicado.enable();
              // this.formData.controls.comunaPagoDuplicado.enable();
              this.spinner.hide();
              return { numClienteExist: true };
            })
          );
        })
      );
    }
  }

  onSuscripcionChange(event) {
    let clientId = this.formData.value.nCliente;
    
    if (clientId === "") {
      alert(
        'Es necesario ingresar su número de cliente.'
      );
      this.formData.patchValue({
        suscripcion: false
      });
    } else {
      this.apiService.ConsultaSuscripcionBoletaElectronicaIC(clientId).subscribe((response: any) => {
        console.log("responce de boleta electronica", response)
        // Si retorna un NO, se levanta POPUP de alerta
        if (response.Indicador == "NO" || response.TipoTarifa == "Null") {
          this.formData.patchValue({
            suscripcion: false
          });
          this.formData.get('suscripcion').disable();
          alert(
            'Estimado cliente, la suscripción electrónica no es factible para este número de cliente.'
          );
        }
      });
    }
  }

  getTextClass() {
    return { 'disabled-text': this.formData.get('suscripcion').disabled };
  }

  getCheckboxClass() {
    return { 'disabled-checkbox': this.formData.get('suscripcion').disabled };
  }

  getUserIp(): void {
  fetch('https://api.ipify.org?format=json')
    .then(response => response.json())
    .then(data => {
      this.userIp = data.ip;
    })
    .catch(error => {
      this.userIp = '';
    });
  }

}
